var map = {
	"./en/SDG-01-EN-INVERTED.png": "4694",
	"./en/SDG-02-EN-INVERTED.png": "6aec",
	"./en/SDG-03-EN-INVERTED.png": "9a7e",
	"./en/SDG-04-EN-INVERTED.png": "3c74",
	"./en/SDG-05-EN-INVERTED.png": "1d54",
	"./en/SDG-06-EN-INVERTED.png": "e802",
	"./en/SDG-07-EN-INVERTED.png": "e2e8",
	"./en/SDG-08-EN-INVERTED.png": "5b26",
	"./en/SDG-09-EN-INVERTED.png": "9064",
	"./en/SDG-10-EN-INVERTED.png": "4f23",
	"./en/SDG-11-EN-INVERTED.png": "7d03",
	"./en/SDG-12-EN-INVERTED.png": "273e",
	"./en/SDG-13-EN-INVERTED.png": "ca2d",
	"./en/SDG-14-EN-INVERTED.png": "da18",
	"./en/SDG-15-EN-INVERTED.png": "2f11",
	"./en/SDG-16-EN-INVERTED.png": "683d",
	"./en/SDG-17-EN-INVERTED.png": "8e88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f21d";